import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../store'

interface TabCountState {
  /**
   * Dynamic count for Tab 1 (My Time Off Requests).
   * In List View: equals totalRecords from employeeInfo.timeOffRequests
   * In Calendar View: equals the count of requests in the currently displayed week
   */
  timeOffRequestsCount: number
}

const initialState: TabCountState = {
  timeOffRequestsCount: 0,
}

/**
 * Redux slice for managing dynamic tab counts in the Requestor flow.
 * This allows components like TimeOffRequests to update the displayed count
 * based on view mode (List vs Calendar) and current filters/week selection.
 */
const requestorTabCountSlice = createSlice({
  name: 'requestorTabCount',
  initialState,
  reducers: {
    /**
     * Update the count displayed for Tab 1 (My Time Off Requests).
     * @param state - Current slice state
     * @param action - Payload containing the new count
     */
    setTimeOffRequestsCount(state, action: PayloadAction<number>) {
      state.timeOffRequestsCount = action.payload
    },
    /**
     * Reset all tab counts to initial state.
     * Useful when navigating away from the Requestor section.
     */
    resetTabCounts() {
      return initialState
    },
  },
})

export const { setTimeOffRequestsCount, resetTabCounts } = requestorTabCountSlice.actions

export const selectTimeOffRequestsCount = (state: RootState) =>
  state.requestorTabCount.timeOffRequestsCount

export default requestorTabCountSlice.reducer
